// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidationRadialChartStyle__container--3YPhF","small":"ValidationRadialChartStyle__small--29A00"};